/**
 * The type of storage
 */
export enum StorageType {
  /**
   * Stores Entity Service documents to improve description
   * and provide extra information about it.
   */
  EntityServiceDocument = 'entity-service-document',

  /**
   * Stores Entity Service image to place on the app button.
   */
  EntityServiceImage = 'entity-service-image',

  /**
   * Upload a message in a video file to be sent to other users.
   */
  VideoMessage = 'video-message',

  /**
   * Upload a photo, related to a senior user, to be kept private or shared with other users.
   */
  Photo = 'photo',

  /**
   * Upload a video, related to a senior user, to be kept private or shared with other users.
   */
  Video = 'video',

  /**
   * Upload a drawing, related to a senior user, to be kept private or shared with other users.
   */
  Drawing = 'drawing',

  /**
   * Stores an Entity picture, like a logo or something else representing the entity.
   */
  EntityPicture = 'entity-picture',

  /**
   * Stores Entity Services image to represent the entity services as a group.
   */
  EntityServicesImage = 'entity-services-image',

  /**
   * Stores an User picture, like a photograph or something else representing the user.
   */
  UserPicture = 'user-picture',

  /**
   * Upload a photo, related to an entity.
   */
  EntityPhoto = 'entity-photo',

  /**
   * Stores a playlist image, like a photograph or something else representing the playlist.
   */
  PlaylistImage = 'playlist-image',

  /**
   * Stores a playlist item thumbnail, like a photograph or something else representing the playlist item.
   */
  PlaylistItemThumbnail = 'playlist-item-thumbnail',

  /**
   * Stores a care task attachment, like a photograph, video or document.
   */
  CareTaskAttachment = 'care-task-attachment',

  /**
   * Stores a care task attachment, like a photograph, video or document.
   */

  OccurrenceAttachment = 'occurrence-attachment',
}
